import { render } from "./ViewUsers.vue?vue&type=template&id=c8c7fe48&scoped=true&ts=true"
import script from "./ViewUsers.vue?vue&type=script&lang=ts"
export * from "./ViewUsers.vue?vue&type=script&lang=ts"

import "./ViewUsers.vue?vue&type=style&index=0&id=c8c7fe48&lang=scss&scoped=true"

import exportComponent from "/builds/Chirbou/isolation/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8c7fe48"]])

export default __exports__